/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
export default {
  SET_LIST(state, data) {
    state.list = data.items;
    if (data && data.pagination) {
      state.pagination = { ...state.pagination, ...data.pagination };
    }
  },
  SET_SELF_STUDY(state, data) {
    state.listSelfStudyCourse = data.items;
  },
  SET_DETAIL(state, workingtime) {
    state.selecting = workingtime;
  },
  ADD_WORKING_TIME(state, workingtime) {
    state.list.push(workingtime);
  },
  UPDATE_WORKING_TIME(state, workingtime) {
    const index = state.list.findIndex((u) => u.id === workingtime.id);
    if (index >= 0) {
      state.list.splice(index, 1, workingtime);
    }
  },
  DELETE_WORKING_TIME_ITEM(state, working_time_id) {
    const itemIndex = state.list.findIndex(
      (item) => item.id === working_time_id,
    );
    if (itemIndex >= 0) {
      state.list.splice(itemIndex, 1);
    }
  },
};
